import React from 'react';
import { Box, Container, Typography, Button, Grid, Paper } from '@mui/material';
import { Bolt, LocalGasStation, Speed, Verified, Phone, RequestQuote, LocationOn } from '@mui/icons-material';
import { siteConfig } from '../config/siteConfig';

const Hero = () => {
    const features = [
        { icon: <Bolt sx={{ fontSize: 40 }} />, label: 'Mehr Leistung' },
        { icon: <LocalGasStation sx={{ fontSize: 40 }} />, label: 'Weniger Verbrauch' },
        { icon: <Speed sx={{ fontSize: 40 }} />, label: 'Besseres Ansprechverhalten' },
        { icon: <Verified sx={{ fontSize: 40 }} />, label: '2 Jahre Garantie' }
    ];

    return (
        <Box sx={{
            position: 'relative',
            minHeight: '90vh',
            display: 'flex',
            alignItems: 'center',
            color: 'white',
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'url(https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1920&q=80)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'brightness(0.4)',
                zIndex: -1
            }
        }}>
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Top Badge */}
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Box
                        sx={{
                            display: 'inline-block',
                            bgcolor: siteConfig.colors.primary,
                            color: 'white',
                            px: 4,
                            py: 1.5,
                            borderRadius: 50,
                            fontWeight: 'bold',
                            fontSize: '1rem'
                        }}
                    >
                        #1 Chiptuning Spezialist in Deutschland
                    </Box>
                </Box>

                {/* Main Title */}
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 'bold',
                            mb: 2,
                            fontSize: { xs: '2.5rem', md: '3.5rem' }
                        }}
                    >
                        Professionelles Chiptuning
                    </Typography>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 'bold',
                            color: siteConfig.colors.primary,
                            mb: 3,
                            fontSize: { xs: '2.5rem', md: '3.5rem' }
                        }}
                    >
                        für maximale Leistung
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: 'rgba(255,255,255,0.9)',
                            maxWidth: '700px',
                            margin: '0 auto',
                            fontSize: { xs: '1rem', md: '1.25rem' }
                        }}
                    >
                        Jetzt bis zu 30% Rabatt sichern und Ihr Fahrzeug mit modernster Technologie optimieren
                    </Typography>
                </Box>

                {/* Feature Icons */}
                <Grid container spacing={3} sx={{ mb: 6, justifyContent: 'center' }}>
                    {features.map((feature, index) => (
                        <Grid item xs={6} sm={3} key={index}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 3,
                                    textAlign: 'center',
                                    bgcolor: 'rgba(255,255,255,0.1)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    color: 'white',
                                    transition: 'all 0.3s',
                                    '&:hover': {
                                        bgcolor: 'rgba(255,255,255,0.15)',
                                        transform: 'translateY(-5px)'
                                    }
                                }}
                            >
                                <Box sx={{ color: siteConfig.colors.primary, mb: 1 }}>
                                    {feature.icon}
                                </Box>
                                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
                                    {feature.label}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                {/* CTA Buttons */}
                <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', mb: 4 }}>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<Phone />}
                        sx={{
                            bgcolor: siteConfig.colors.primary,
                            px: 4,
                            py: 2,
                            fontSize: '1.1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            borderRadius: 50,
                            boxShadow: '0 8px 24px rgba(231, 76, 60, 0.4)',
                            '&:hover': {
                                bgcolor: '#c0392b',
                                boxShadow: '0 12px 32px rgba(231, 76, 60, 0.5)'
                            }
                        }}
                    >
                        Jetzt Anrufen
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<RequestQuote />}
                        sx={{
                            bgcolor: siteConfig.colors.primary,
                            px: 4,
                            py: 2,
                            fontSize: '1.1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            borderRadius: 50,
                            boxShadow: '0 8px 24px rgba(231, 76, 60, 0.4)',
                            '&:hover': {
                                bgcolor: '#c0392b',
                                boxShadow: '0 12px 32px rgba(231, 76, 60, 0.5)'
                            }
                        }}
                    >
                        Angebot Einholen
                    </Button>
                </Box>

                {/* Location */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    <LocationOn sx={{ color: siteConfig.colors.primary }} />
                    <Typography variant="body1">
                        Flämingstraße 3–4 · 15738 · Zeuthen.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Hero;